/*
 * Where the telemetry service lives.
 *
 * Its own module because both `client.ts` (snapshots) and `auth.ts` (sign-in)
 * need it, and having either import it from the other would make a cycle —
 * the kind that resolves to `undefined` at module-evaluation time and shows up
 * as a fetch to "undefined/v1/auth/params" rather than as a build error.
 *
 * Unset means the dashboard runs on the seeded generator, which is also the
 * mode where there is nothing to sign in to.
 */

export const API_BASE =
  (import.meta.env.VITE_API_BASE_URL as string | undefined)?.replace(/\/$/, '') ?? '';

export const isLiveConfigured = Boolean(API_BASE);
